function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTemplates(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 72 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M49,61H23a5.0147,5.0147,0,0,1-5-5V16a5.0147,5.0147,0,0,1,5-5H40.9091L54,22.1111V56A5.0147,5.0147,0,0,1,49,61Z",
    style: {
      fill: "#e3edfc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54,22.1111H44.1818a3.3034,3.3034,0,0,1-3.2727-3.3333V11s1.8409.2083,6.9545,4.5833C52.8409,20.0972,54,22.1111,54,22.1111Z",
    style: {
      fill: "#b7d0ea"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.03,59A4.9835,4.9835,0,0,0,23,61H49a4.9835,4.9835,0,0,0,3.97-2Z",
    style: {
      fill: "#c4dbf2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.7086,39.7209a2.0073,2.0073,0,0,1-.6719-1.13,13.6516,13.6516,0,0,1-.177-2.5892,20.1435,20.1435,0,0,0-.1409-2.6986,2.8313,2.8313,0,0,0-.5677-1.365,2.392,2.392,0,0,0-1.1045-.771A4.7219,4.7219,0,0,0,40.567,31h-.5834v1.6358h.323a2.2358,2.2358,0,0,1,1.3286.2761,1.3951,1.3951,0,0,1,.4115.9741q.052.396.0521,2.4278a7.4367,7.4367,0,0,0,.49,3.1831,3.5212,3.5212,0,0,0,1.688,1.5161A3.2462,3.2462,0,0,0,42.86,42.0913a4.1332,4.1332,0,0,0-.6668,1.8494q-.0938.6979-.0939,3.3029a2.8665,2.8665,0,0,1-.3542,1.7558,1.9512,1.9512,0,0,1-1.4379.3907h-.323v1.6358h.5834a5.15,5.15,0,0,0,1.2922-.1147,2.3263,2.3263,0,0,0,1.5888-1.3283,4.3336,4.3336,0,0,0,.3491-1.412q.052-.5522.0626-2.2922a12.6415,12.6415,0,0,1,.177-2.4537,2.0068,2.0068,0,0,1,.6719-1.13,2.0779,2.0779,0,0,1,1.3077-.4377V40.1586A2.0779,2.0779,0,0,1,44.7086,39.7209Z",
    style: {
      fill: "#0089ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1458,39.94a3.9507,3.9507,0,0,0,.6409-1.7192,30.109,30.109,0,0,0,.1145-3.4486,2.8422,2.8422,0,0,1,.3542-1.7454,1.9513,1.9513,0,0,1,1.4379-.3906h.3229V31h-.5834a5.6351,5.6351,0,0,0-1.292.1042,2.3154,2.3154,0,0,0-1.589,1.3336,4.3657,4.3657,0,0,0-.3491,1.4064q-.052.5525-.0624,2.2925a12.753,12.753,0,0,1-.1772,2.4588,1.9824,1.9824,0,0,1-.6719,1.13,2.0961,2.0961,0,0,1-1.3077.4326v1.6981a2.0781,2.0781,0,0,1,1.3077.4377,2.0086,2.0086,0,0,1,.6719,1.1358,13.7531,13.7531,0,0,1,.1772,2.5943,20.1384,20.1384,0,0,0,.1407,2.6987,2.7975,2.7975,0,0,0,.5676,1.36,2.4768,2.4768,0,0,0,1.1046.7762,4.7123,4.7123,0,0,0,1.48.1669h.5834V49.39h-.3229a2.2033,2.2033,0,0,1-1.3286-.2813,1.4643,1.4643,0,0,1-.422-.99q-.0414-.3855-.0417-2.4173a7.3922,7.3922,0,0,0-.5158-3.2247,3.179,3.179,0,0,0-1.6618-1.4639A3.8127,3.8127,0,0,0,30.1458,39.94Z",
    style: {
      fill: "#0089ff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemplates);
export default __webpack_public_path__ + "static/media/templates.8de80a3ddb1c76590da9fefdc3313ac9.svg";
export { ForwardRef as ReactComponent };